import React, {
  createContext,
  useContext,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';

const MapStateContext = createContext(null);

export const MapStateProvider = ({ children, externalRef }) => {
  const [mapState, setMapStateInternal] = useState({
    isMapMode: false,
    zoom: 6,
    bounds: null,
    visibleCount: null,
    sidebarHidden: false,
  });

  const internalRef = useRef(mapState);
  const mapStateRef = externalRef || internalRef;

  const setMapState = useCallback(newState => {
    const updated =
      typeof newState === 'function' ? newState(mapStateRef.current) : newState;
    mapStateRef.current = updated;
    setMapStateInternal(updated);
  }, []);

  const contextValue = useMemo(
    () => ({ mapState, setMapState, mapStateRef }),
    [mapState, setMapState, mapStateRef],
  );

  return (
    <MapStateContext.Provider value={contextValue}>
      {children}
    </MapStateContext.Provider>
  );
};

export const useMapState = () => {
  const context = useContext(MapStateContext);

  if (!context) {
    return {
      mapState: {
        isMapMode: false,
        zoom: 6,
        bounds: null,
        visibleCount: null,
        sidebarHidden: false,
      },
      setMapState: () => {},
      mapStateRef: {
        current: {
          isMapMode: false,
          zoom: 6,
          bounds: null,
          visibleCount: null,
          sidebarHidden: false,
        },
      },
    };
  }

  return context;
};
